/* TARAYA product gallery: tolerant arrow bounds + Apple-style dots.
   Origin's SliderComponent compares scroll positions with exact pixel
   equality, which sub-pixel slide widths break; bounds here use a 2px
   tolerance. The numeric counter is hidden in CSS and replaced with one
   dot per visible image, click-to-navigate, active state synced on
   scroll, rebuilt if the visible image set changes (variant filtering). */
(function () {
  function init() {
    document.querySelectorAll("media-gallery[data-desktop-layout='stacked']").forEach(function (gal) {
      var slider = gal.querySelector("ul[id^='Slider-Gallery']");
      var buttonsRow = gal.querySelector(".slider-buttons");
      var prev = gal.querySelector(".slider-button--prev");
      var next = gal.querySelector(".slider-button--next");
      if (!slider || !buttonsRow || !prev || !next) return;

      var dotsWrap = document.createElement("div");
      dotsWrap.className = "taraya-dots";
      dotsWrap.setAttribute("role", "tablist");
      dotsWrap.setAttribute("aria-label", "Gallery pagination");
      var counter = buttonsRow.querySelector(".slider-counter");
      buttonsRow.insertBefore(dotsWrap, counter || next);

      function slides() {
        return Array.prototype.filter.call(
          slider.querySelectorAll(".product__media-item"),
          function (el) { return el.clientWidth > 0; }
        );
      }

      function step(items) {
        return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
      }

      /* 24 Jul, motion audit round 2: paged glide. The desktop carousel
         previously relied on CSS scroll-behavior: smooth, whose easing is
         the browser's and cannot be tuned. This tween drives paging with
         the brand --ease-in-out curve, cubic-bezier(0.77, 0, 0.175, 1),
         400ms per page (on-screen movement, not an entrance, so in-out is
         the correct family). Interruptible: a new press retargets from
         the live scroll position; a manual wheel, touch or drag cancels
         the tween and hands control back instantly. Reduced motion and
         sub-750px widths never enter this path. Snap and CSS smooth are
         suspended only while the tween runs so they cannot fight it, and
         restored on settle. Known limit, accepted: retargeting restarts
         from zero velocity, not the live velocity; the in-out curve's
         zero starting slope makes the seam invisible in practice. */
      var rafId = null;
      var tweenActive = false;

      function easeInOut(p) {
        /* cubic-bezier(0.77, 0, 0.175, 1) solved for x = p */
        var x1 = 0.77, y1 = 0, x2 = 0.175, y2 = 1;
        function bez(t, a, b) {
          var u = 1 - t;
          return 3 * u * u * t * a + 3 * u * t * t * b + t * t * t;
        }
        var lo = 0, hi = 1, t = p;
        for (var i = 0; i < 20; i++) {
          var x = bez(t, x1, x2);
          if (Math.abs(x - p) < 0.0005) break;
          if (x < p) lo = t; else hi = t;
          t = (lo + hi) / 2;
        }
        return bez(t, y1, y2);
      }

      function endTween() {
        if (rafId !== null) cancelAnimationFrame(rafId);
        rafId = null;
        if (tweenActive) {
          slider.style.scrollBehavior = "";
          slider.style.scrollSnapType = "";
          tweenActive = false;
        }
      }

      function glide(target) {
        var wide = window.matchMedia("(min-width: 750px)").matches;
        var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (still) { endTween(); slider.scrollTo({ left: target }); return; }
        if (!wide) { endTween(); slider.scrollTo({ left: target, behavior: "smooth" }); return; }
        endTween();
        var from = slider.scrollLeft;
        var change = target - from;
        if (!change) return;
        tweenActive = true;
        slider.style.scrollBehavior = "auto";
        slider.style.scrollSnapType = "none";
        var t0 = null;
        var D = 400;
        function frame(now) {
          if (t0 === null) t0 = now;
          var p = Math.min((now - t0) / D, 1);
          slider.scrollLeft = from + change * easeInOut(p);
          if (p < 1) {
            rafId = requestAnimationFrame(frame);
          } else {
            endTween();
          }
        }
        rafId = requestAnimationFrame(frame);
      }

      /* Direct manipulation wins instantly: any manual input grabs
         control back from the tween (apple-design, interruptibility). */
      ["wheel", "touchstart", "pointerdown"].forEach(function (type) {
        slider.addEventListener(type, endTween, { passive: true });
      });

      /* Arrows route through the tween at desktop. Capture phase runs
         before SliderComponent's own click handler; stopPropagation
         keeps it from double-scrolling. Keyboard-invoked clicks
         (event.detail === 0) fall through untouched: keyboard actions
         do not animate. */
      [prev, next].forEach(function (btn) {
        btn.addEventListener(
          "click",
          function (e) {
            if (e.detail === 0) return;
            if (!window.matchMedia("(min-width: 750px)").matches) return;
            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
            var items = slides();
            var off = step(items);
            if (!off) return;
            e.preventDefault();
            e.stopPropagation();
            var max = slider.scrollWidth - slider.clientWidth;
            var idx = Math.round(slider.scrollLeft / off);
            var dir = btn === next ? 1 : -1;
            glide(Math.max(0, Math.min((idx + dir) * off, max)));
          },
          { capture: true }
        );
      });

      function rebuild() {
        var items = slides();
        dotsWrap.innerHTML = "";
        items.forEach(function (item, i) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "taraya-dot";
          dot.setAttribute("aria-label", "Go to image " + (i + 1) + " of " + items.length);
          dot.addEventListener("click", function () {
            glide(step(items) * i);
          });
          dotsWrap.appendChild(dot);
        });
        return items;
      }

      var current = rebuild();

      function sync() {
        requestAnimationFrame(function () {
          var items = slides();
          if (items.length !== current.length) current = rebuild();
          var max = slider.scrollWidth - slider.clientWidth;
          prev.toggleAttribute("disabled", slider.scrollLeft <= 2);
          next.toggleAttribute("disabled", slider.scrollLeft >= max - 2);
          var offset = step(items);
          var index = offset > 0 ? Math.round(slider.scrollLeft / offset) : 0;
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            if (i === index) dot.setAttribute("aria-current", "true");
            else dot.removeAttribute("aria-current");
          });
        });
      }

      slider.addEventListener("scroll", sync, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(sync).observe(slider);
      new MutationObserver(sync).observe(slider, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class", "style"]
      });
      sync();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* Variant-synced gross weight line: Origin re-renders price/SKU on variant
   change but not custom liquid blocks, so all variant weights render as
   spans and this toggles the matching one via Origin's own pubsub. */
(function () {
  function initWeights() {
    var wrap = document.querySelector("[data-taraya-weights]");
    if (!wrap || typeof window.subscribe !== "function" || !window.PUB_SUB_EVENTS) return;
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      wrap.querySelectorAll("[data-variant-weight]").forEach(function (el) {
        el.hidden = el.getAttribute("data-variant-weight") !== String(variant.id);
      });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWeights);
  } else {
    initWeights();
  }
})();

/* Custom sort dropdown: replaces the native desktop select with a panel
   styled like the header's Catalog dropdown. The native select stays in
   the DOM (hidden) so facet form serialisation and fallbacks keep working;
   choosing an option sets its value and fires input/change so Origin's
   FacetFiltersForm fetches the sorted grid. Facets re-render on every
   filter change, so a MutationObserver re-enhances when needed. Mobile
   keeps the native control inside the drawer.
   Rebuild-safe (Aug 26 fix): keyboard wiring lives inside enhance() so
   every rebuilt control carries it (previously it bound once at load
   and died on the first facet re-render), and the outside-click and
   Escape handlers are bound ONCE at document level using delegation
   against the current .taraya-sort, so re-renders no longer accumulate
   document listeners holding dead closures. */
(function () {
  function currentWrap() {
    return document.querySelector(".taraya-sort");
  }

  function closeWrap(wrap) {
    if (!wrap) return;
    var btn = wrap.querySelector(".taraya-sort__button");
    var list = wrap.querySelector(".taraya-sort__list");
    if (list) list.hidden = true;
    if (btn) btn.setAttribute("aria-expanded", "false");
  }

  function enhance() {
    var select = document.getElementById("SortBy");
    if (!select || select.dataset.tarayaEnhanced) return;
    var shell = select.closest(".select");
    if (!shell) return;
    select.dataset.tarayaEnhanced = "true";
    shell.classList.add("taraya-sort-native");

    var wrap = document.createElement("div");
    wrap.className = "taraya-sort";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "taraya-sort__button";
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    var labelSpan = document.createElement("span");
    btn.appendChild(labelSpan);
    var list = document.createElement("ul");
    list.className =
      "taraya-sort__list header__submenu list-menu list-menu--disclosure " +
      "color-scheme-1 gradient caption-large global-settings-popup";
    list.setAttribute("role", "listbox");
    list.hidden = true;

    function refresh() {
      var o = select.options[select.selectedIndex];
      labelSpan.textContent = o ? o.textContent.trim() : "";
      Array.prototype.forEach.call(list.querySelectorAll(".taraya-sort__option"), function (el) {
        var active = el.dataset.value === select.value;
        el.setAttribute("aria-selected", active ? "true" : "false");
        el.classList.toggle("list-menu__item--active", active);
      });
    }
    function toggle(openIt) {
      list.hidden = !openIt;
      btn.setAttribute("aria-expanded", openIt ? "true" : "false");
    }
    function options() {
      return Array.prototype.slice.call(list.querySelectorAll(".taraya-sort__option"));
    }

    Array.prototype.forEach.call(select.options, function (opt) {
      var li = document.createElement("li");
      var ob = document.createElement("button");
      ob.type = "button";
      ob.className =
        "taraya-sort__option header__menu-item list-menu__item link link--text focus-inset caption-large";
      ob.setAttribute("role", "option");
      ob.dataset.value = opt.value;
      ob.textContent = opt.textContent.trim();
      ob.addEventListener("click", function () {
        toggle(false);
        if (select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event("input", { bubbles: true }));
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
        refresh();
      });
      li.appendChild(ob);
      list.appendChild(li);
    });

    btn.addEventListener("click", function () {
      toggle(list.hidden);
    });

    /* Keyboard: bound per build on the fresh nodes, discarded with them. */
    btn.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
        if (list.hidden) toggle(true);
        var opts = options();
        var current = opts.findIndex(function (o) { return o.getAttribute("aria-selected") === "true"; });
        (opts[current] || opts[0]).focus();
        e.preventDefault();
      }
    });
    list.addEventListener("keydown", function (e) {
      var opts = options();
      var i = opts.indexOf(document.activeElement);
      if (e.key === "ArrowDown") { (opts[i + 1] || opts[0]).focus(); e.preventDefault(); }
      else if (e.key === "ArrowUp") { (opts[i - 1] || opts[opts.length - 1]).focus(); e.preventDefault(); }
      else if (e.key === "Home") { opts[0].focus(); e.preventDefault(); }
      else if (e.key === "End") { opts[opts.length - 1].focus(); e.preventDefault(); }
      else if (e.key === "Escape") { toggle(false); btn.focus(); e.preventDefault(); }
    });

    wrap.appendChild(btn);
    wrap.appendChild(list);
    shell.parentNode.insertBefore(wrap, shell.nextSibling);
    refresh();
  }

  /* Document-level dismissal: bound exactly once, resolves the live
     control at event time instead of closing over a build. */
  document.addEventListener("click", function (e) {
    var wrap = currentWrap();
    if (wrap && !wrap.contains(e.target)) closeWrap(wrap);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeWrap(currentWrap());
  });

  function boot() {
    enhance();
    var container = document.querySelector(".facets-container");
    if (container && window.MutationObserver) {
      new MutationObserver(enhance).observe(container, { subtree: true, childList: true });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* Contact form: Shopify's /contact endpoint hard-requires the email field
   (it is the delivery and reply-to mechanism), so email stays mandatory.
   Name and phone, which matter more for gifting enquiries, are promoted
   to required here without editing Origin's section file, so the theme
   update pathway stays clean. Labels gain an asterisk to say so. */
(function () {
  function initContact() {
    var name = document.getElementById("ContactForm-name");
    var phone = document.getElementById("ContactForm-phone");
    [name, phone].forEach(function (el) {
      if (!el) return;
      el.required = true;
      el.setAttribute("aria-required", "true");
      var label = document.querySelector('label[for="' + el.id + '"]');
      if (label && label.textContent.indexOf("*") === -1) {
        label.textContent = label.textContent.trim() + " *";
      }
    });
    if (phone) {
      phone.setAttribute("inputmode", "tel");
      /* Counts digits, not characters: the old pattern accepted eight
         plus signs. Full-string match, 8-15 digits, separators free. */
      phone.setAttribute("pattern", "(?:[+\\(\\)\\-\\s]*\\d){8,15}[+\\(\\)\\-\\s]*");
      phone.setAttribute("title", "Enter a phone number with 8 to 15 digits");
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContact);
  } else {
    initContact();
  }
})();

/* Input-modality tracking for focus rings. Pure CSS :focus-visible can't
   distinguish a keyboard Tab from programmatic focus (e.g. the cart icon
   after the drawer closes), so the header-icon ring was firing on mouse
   interactions. This flags <html> only while the keyboard is the active
   input; brand-taraya.css scopes the header-icon focus ring to that flag. */
(function () {
  var root = document.documentElement;
  window.addEventListener("keydown", function (e) {
    if (e.key === "Tab") root.classList.add("taraya-using-keyboard");
  }, true);
  ["mousedown", "pointerdown", "touchstart"].forEach(function (evt) {
    window.addEventListener(evt, function () {
      root.classList.remove("taraya-using-keyboard");
    }, true);
  });
})();

/* Sort dropdown keyboard navigation now lives inside enhance() above,
   so rebuilt controls keep it after every facet re-render. */

/* Cart drawer reassurance line. Injected into the drawer footer above the
   checkout CTA rather than editing Origin's cart-drawer snippet, so theme
   updates stay clean. Re-runs when the cart section re-renders. */
(function () {
  function injectReassurance() {
    var footer = document.querySelector(".cart-drawer__footer");
    if (!footer || footer.querySelector(".taraya-cart-reassure")) return;
    var el = document.createElement("p");
    el.className = "taraya-cart-reassure";
    el.textContent = "Insured shipping across India · Every piece certified";
    footer.insertBefore(el, footer.firstChild);
  }
  function boot() {
    injectReassurance();
    var cart = document.querySelector("cart-drawer");
    if (cart && window.MutationObserver) {
      new MutationObserver(injectReassurance).observe(cart, { subtree: true, childList: true });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();

/* Apple-pattern quick links inside the search modal: visible before a
   query exists, gone once typing starts, back when the field clears.
   Injected here so Origin's header-search snippet stays unedited. */
(function () {
  function initQuickLinks() {
    var form = document.querySelector(".search-modal__form form.search");
    if (!form || form.querySelector(".taraya-quicklinks")) return;
    var input = form.querySelector(".search__input");
    var nav = document.createElement("nav");
    nav.className = "taraya-quicklinks";
    nav.setAttribute("aria-label", "Quick links");
    nav.innerHTML =
      '<p class="taraya-quicklinks__label">Quick links</p>' +
      '<ul class="taraya-quicklinks__list">' +
      '<li><a href="/collections/silver-idols">Silver Idols</a></li>' +
      '<li><a href="/collections/auspicious-vahanas">Auspicious Vahanas</a></li>' +
      '<li><a href="/collections/photo-frames">Semi-precious Photo Frames</a></li>' +
      '<li><a href="/pages/contact">Contact us</a></li>' +
      "</ul>";
    form.appendChild(nav);
    if (input) {
      input.addEventListener("input", function () {
        nav.hidden = input.value.trim().length > 0;
      });
      /* Reset fires no input event, so the panel stayed hidden after
         the clear button (the ghost had this fix; this pane did not). */
      form.addEventListener("reset", function () {
        setTimeout(function () { nav.hidden = false; }, 0);
      });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initQuickLinks);
  } else { initQuickLinks(); }
})();

/* Ghost completion: mirrors the top predictive suggestion behind the
   typed query. Reads Origin's own predictive results when they render,
   so it needs no extra network calls and always agrees with the panel
   beneath. ArrowRight or Tab (caret at end) accepts. */
(function () {
  function initGhost() {
    var form = document.querySelector(".search-modal__form form.search");
    if (!form || form.querySelector(".taraya-ghost")) return;
    var input = form.querySelector(".search__input");
    // Observe ONLY the results container (a sibling of the form), never an
    // ancestor of the ghost span: observing an ancestor made the ghost's own
    // text updates re-trigger the observer in an infinite loop.
    var results = document.querySelector(".search-modal div.predictive-search") ||
                  document.querySelector(".search-modal [data-predictive-search]:not(predictive-search)");
    if (!input) return;

    var ghost = document.createElement("span");
    ghost.className = "taraya-ghost";
    ghost.setAttribute("aria-hidden", "true");
    ghost.innerHTML = '<span class="taraya-ghost__prefix"></span><span class="taraya-ghost__rest"></span>';
    form.appendChild(ghost);
    var prefix = ghost.firstChild;
    var rest = ghost.lastChild;
    var completion = "";

    function clearGhost() {
      completion = "";
      prefix.textContent = "";
      rest.textContent = "";
    }

    function updateGhost() {
      var q = input.value;
      if (!q || !results) return clearGhost();
      var candidates = results.querySelectorAll(
        ".predictive-search__item-heading, .predictive-search__item-query-result, .predictive-search__item [role='option'], .predictive-search__list-item a"
      );
      completion = "";
      for (var i = 0; i < candidates.length; i++) {
        var text = (candidates[i].textContent || "").trim().replace(/\s+/g, " ");
        if (text && text.toLowerCase().indexOf(q.toLowerCase()) === 0 && text.length > q.length) {
          completion = text;
          break;
        }
      }
      if (!completion) return clearGhost();
      // Write only on change: belt-and-braces against any observer echo.
      if (prefix.textContent !== q) prefix.textContent = q;
      var remainder = completion.slice(q.length);
      if (rest.textContent !== remainder) rest.textContent = remainder;
    }

    input.addEventListener("input", function () {
      if (!input.value) clearGhost();
    });

    // Form reset does NOT fire an input event, so the ghost was surviving
    // the reset button with stale text. Clear on reset (after values flush)
    // and whenever the search modal closes.
    form.addEventListener("reset", function () {
      setTimeout(clearGhost, 0);
    });
    var modalDetails = form.closest("details");
    if (modalDetails) {
      modalDetails.addEventListener("toggle", function () {
        if (!modalDetails.open) clearGhost();
      });
    }

    if (results && window.MutationObserver) {
      new MutationObserver(updateGhost).observe(results, { childList: true, subtree: true });
    }

    /* ArrowRight only. Tab was removed from the accept keys (Aug 26):
       hijacking Tab trapped keyboard users in the field whenever a
       completion existed, and Tab must remain focus navigation. */
    input.addEventListener("keydown", function (e) {
      if (!completion) return;
      var atEnd = input.selectionStart === input.value.length;
      if (e.key === "ArrowRight" && atEnd && input.value.length) {
        input.value = completion;
        clearGhost();
        input.dispatchEvent(new Event("input", { bubbles: true }));
        e.preventDefault();
      }
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGhost);
  } else { initGhost(); }
})();

/* Lazy-image load fade. Only images not yet complete get the pending
   class, so cached images and the eager hero never flash or delay. */
(function () {
  function watch(img) {
    if (img.complete || img.loading !== "lazy") return;
    img.classList.add("taraya-img-pending");
    img.addEventListener("load", function () {
      img.classList.add("taraya-img-loaded");
      img.classList.remove("taraya-img-pending");
    }, { once: true });
    img.addEventListener("error", function () {
      img.classList.remove("taraya-img-pending");
    }, { once: true });
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("img[loading='lazy']"), watch);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();

/* Card title split moved to Liquid: snippets/taraya-card-title.liquid now
   renders the name and the custom.card_caption subline server-side, so the
   old " on " JavaScript split (and its first-paint flash) is retired. */


/* TARAYA micro-feedback (added on request): cart badge pop, cart content
   crossfade, filtered-grid fade. Each only adds a class; the motion and its
   reduced-motion gating live in brand-taraya.css. All attach after load, so
   none fire on first paint. */
(function () {
  var MO = window.MutationObserver;

  var bubbleHost = document.getElementById("cart-icon-bubble");
  if (bubbleHost && MO) {
    new MO(function () {
      var bubble = bubbleHost.querySelector(".cart-count-bubble");
      if (bubble) bubble.classList.add("taraya-pop");
    }).observe(bubbleHost, { childList: true });
  }

  var grid = document.getElementById("ProductGridContainer");
  if (grid && MO) {
    new MO(function () {
      var coll = grid.querySelector(".collection");
      if (coll) coll.classList.add("taraya-grid-in");
    }).observe(grid, { childList: true });
  }

  /* Cart content crossfade: Origin hard-swaps innerHTML on every cart update
     (add, remove, quantity change). We observe the swap target and fade the
     entire drawer interior after the re-render lands. This replaced the old
     row-level collapse which left orphaned headers and a stale total visible
     in the gap between CSS animation and server re-render. */
  var cartItems = document.getElementById("CartDrawer-CartItems");
  if (cartItems && MO) {
    new MO(function () {
      var inner = cartItems.closest(".drawer__inner");
      if (inner) {
        inner.classList.remove("taraya-cart-refresh");
        void inner.offsetWidth;
        inner.classList.add("taraya-cart-refresh");
      }
    }).observe(cartItems, { childList: true, subtree: true });
  }
})();

/* Layout switch: Prestige-style column control at the toolbar's inline
   start. Origin fixes desktop columns in a section setting; this control
   lets the visitor choose 2, 3 or 4 and remembers it. Injected only when
   the drawer-layout toolbar exists, so Vertical mode never shows it.
   facets.js replaces both the toolbar contents and the product grid on
   every filter or sort, so two observers reinstate the control and the
   chosen column count after each swap, the same pattern as the sort
   dropdown above. The column CSS lives in brand-taraya.css under
   LAYOUT SWITCH. */
(function () {
  var KEY = "taraya-grid-cols";
  var COLS = ["2", "3", "4"];
  var DEFAULT_COLS = "3";

  function readCols() {
    try {
      var v = window.localStorage.getItem(KEY);
      return COLS.indexOf(v) > -1 ? v : DEFAULT_COLS;
    } catch (e) {
      return DEFAULT_COLS;
    }
  }

  function saveCols(v) {
    try {
      window.localStorage.setItem(KEY, v);
    } catch (e) {}
  }

  function icon(n) {
    var size = 18;
    var gap = 2;
    var cell = (size - gap * (n - 1)) / n;
    var rects = "";
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        rects +=
          '<rect x="' + (c * (cell + gap)) + '" y="' + (r * (cell + gap)) +
          '" width="' + cell + '" height="' + cell + '" fill="currentColor"/>';
      }
    }
    return (
      '<svg viewBox="0 0 ' + size + " " + size + '" width="17" height="17" aria-hidden="true">' +
      rects +
      "</svg>"
    );
  }

  function applyCols(v) {
    var grid = document.querySelector("ul#product-grid");
    if (grid) grid.dataset.tarayaCols = v;
    var wrap = document.querySelector(".taraya-layout");
    if (wrap) {
      Array.prototype.forEach.call(wrap.querySelectorAll(".taraya-layout__button"), function (b) {
        b.setAttribute("aria-pressed", b.dataset.cols === v ? "true" : "false");
      });
    }
  }

  function buildControl() {
    var toolbar = document.querySelector(".facets-container.facets-container-drawer");
    if (!toolbar || toolbar.querySelector(".taraya-layout")) return;

    var wrap = document.createElement("div");
    wrap.className = "taraya-layout";
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", "Grid layout");

    var names = { 2: "Two columns", 3: "Three columns", 4: "Four columns" };
    COLS.forEach(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "taraya-layout__button";
      b.dataset.cols = v;
      b.setAttribute("aria-label", names[v]);
      b.setAttribute("aria-pressed", "false");
      b.innerHTML = icon(parseInt(v, 10));
      b.addEventListener("click", function () {
        saveCols(v);
        applyCols(v);
      });
      wrap.appendChild(b);
    });

    toolbar.insertBefore(wrap, toolbar.firstChild);
  }

  function boot() {
    if (!document.querySelector(".facets-container.facets-container-drawer")) return;
    buildControl();
    applyCols(readCols());

    var facets = document.querySelector(".facets-container");
    if (facets && window.MutationObserver) {
      new MutationObserver(function () {
        buildControl();
        applyCols(readCols());
      }).observe(facets, { subtree: true, childList: true });
    }
    var gridContainer = document.getElementById("ProductGridContainer");
    if (gridContainer && window.MutationObserver) {
      new MutationObserver(function () {
        applyCols(readCols());
      }).observe(gridContainer, { subtree: true, childList: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* Shoppable image hotspots: <details> gives the popovers native
   toggling; this adds the three behaviours details lacks. Opening a
   hotspot closes its siblings, clicking outside any open hotspot
   closes it, Escape closes and returns focus to the dot. Scoped per
   section so two shoppable images on one page do not fight. Styling
   in brand-taraya.css under SHOPPABLE IMAGE. */
(function () {
  function closeAll(frame, except) {
    Array.prototype.forEach.call(frame.querySelectorAll(".taraya-hotspot[open]"), function (d) {
      if (d !== except) d.removeAttribute("open");
    });
  }

  function boot() {
    var frames = document.querySelectorAll(".taraya-shoppable__frame");
    if (!frames.length) return;

    Array.prototype.forEach.call(frames, function (frame) {
      frame.addEventListener("toggle", function (e) {
        var details = e.target;
        if (details.classList && details.classList.contains("taraya-hotspot") && details.open) {
          closeAll(frame, details);
        }
      }, true);

      frame.addEventListener("keyup", function (e) {
        if (e.key !== "Escape") return;
        var open = frame.querySelector(".taraya-hotspot[open]");
        if (open) {
          open.removeAttribute("open");
          var dot = open.querySelector(".taraya-hotspot__dot");
          if (dot) dot.focus();
        }
      });
    });

    document.addEventListener("click", function (e) {
      Array.prototype.forEach.call(document.querySelectorAll(".taraya-hotspot[open]"), function (d) {
        if (!d.contains(e.target)) d.removeAttribute("open");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* Product accordions under the gallery, the reference's split: the
   info column keeps the selling (price, variants, buy buttons) and
   the reading (accordions) moves beneath the images. Pure re-homing
   of the existing nodes, so no Origin file changes and the details
   elements keep their own behaviour. Desktop only: below 750px the
   accordions return to their original slot so the mobile stack stays
   gallery, buy box, then reading. An anchor node marks the original
   position for the return trip. Re-runs on the theme editor's
   section reload so block edits keep working. The move also slims
   the sticky info column, which is what lets it pin properly. */
(function () {
  var mq = window.matchMedia("(min-width: 750px)");

  function ensureAnchor(firstAccordion) {
    var anchor = document.getElementById("taraya-accordion-anchor");
    if (!anchor && firstAccordion) {
      anchor = document.createElement("span");
      anchor.id = "taraya-accordion-anchor";
      anchor.hidden = true;
      firstAccordion.parentNode.insertBefore(anchor, firstAccordion);
    }
    return anchor;
  }

  function apply() {
    var media = document.querySelector(".product__media-wrapper");
    var info = document.querySelector(".product__info-container");
    if (!media || !info) return;

    var inInfo = info.querySelectorAll(".product__accordion");
    var host = media.querySelector(".taraya-under-gallery");

    if (mq.matches) {
      var accordions = inInfo.length ? inInfo : (host ? host.querySelectorAll(".product__accordion") : []);
      if (!accordions.length) return;
      if (inInfo.length) ensureAnchor(inInfo[0]);
      if (!host) {
        host = document.createElement("div");
        host.className = "taraya-under-gallery";
        media.appendChild(host);
      }
      Array.prototype.forEach.call(accordions, function (a) {
        host.appendChild(a);
      });
    } else if (host) {
      var anchor = document.getElementById("taraya-accordion-anchor");
      Array.prototype.forEach.call(host.querySelectorAll(".product__accordion"), function (a) {
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(a, anchor);
        } else {
          info.appendChild(a);
        }
      });
      host.remove();
    }
  }

  function boot() {
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    document.addEventListener("shopify:section:load", apply);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* Deterministic search toggle. Five rounds of styling fixes failed to
   cure a first-tap failure on the search summary on iOS while every
   anchor beside it tapped clean, and details-modal.js's native path
   (click handler, same-tick body listener, trapFocus into the input)
   is where the remaining suspects all live. This reroutes around the
   entire pathway: pointerup on the modal, captured, performs the
   toggle directly through the element's own open/close methods, and
   the trailing click is captured and suppressed so the stock handler
   cannot double-toggle. If the click never arrives at all, the eaten
   first tap, pointerup has already done the work; pointerup sits
   upstream of iOS click arbitration and fires when click does not.
   Keyboard activation dispatches click without pointerup and is
   handled on that branch, so Enter and Space still work. */
(function () {
  function boot() {
    var modal = document.querySelector("details-modal.header__search");
    if (!modal || modal.dataset.tarayaToggle) return;
    modal.dataset.tarayaToggle = "true";

    var details = modal.querySelector("details");
    var summary = modal.querySelector("summary");
    if (!details || !summary) return;

    var handledByPointer = false;

    function toggle() {
      if (details.hasAttribute("open")) {
        if (typeof modal.close === "function") modal.close();
        else details.removeAttribute("open");
      } else {
        if (typeof modal.open === "function") modal.open({ target: summary });
        else details.setAttribute("open", "true");
      }
    }

    modal.addEventListener("pointerup", function (e) {
      if (!summary.contains(e.target)) return;
      handledByPointer = true;
      toggle();
      setTimeout(function () { handledByPointer = false; }, 400);
    }, true);

    modal.addEventListener("click", function (e) {
      if (!summary.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!handledByPointer) toggle();
      handledByPointer = false;
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* Quantity as a spoken line: at rest each stepper is replaced by
   "Quantity: 1 · Change", the atelier register, since a single piece
   is this house's overwhelming order. Tapping Change reveals the real
   stepper with focus, so gifting quantities remain two taps away and
   every existing cart-update behaviour is untouched, the component is
   only hidden, never rewired. Progressive: without JS the stepper
   simply shows, the hiding is gated on the attribute this code sets.
   Value stays live on the line via the input's own events. */
(function () {
  function enhance(q) {
    if (q.dataset.tarayaQty) return;
    var input = q.querySelector(".quantity__input");
    if (!input) return;
    q.dataset.tarayaQty = "rest";

    var line = document.createElement("button");
    line.type = "button";
    line.className = "taraya-qty-line";

    function label() {
      line.innerHTML =
        '<span class="taraya-qty-line__text">Quantity: ' + (input.value || "1") + "</span>" +
        '<span class="taraya-qty-line__action">Change</span>';
      line.setAttribute("aria-label", "Change quantity, currently " + (input.value || "1"));
    }

    label();
    input.addEventListener("change", label);
    input.addEventListener("input", label);

    line.addEventListener("click", function () {
      q.dataset.tarayaQty = "open";
      input.focus();
    });

    q.parentNode.insertBefore(line, q);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("quantity-input.quantity"), enhance);
  }

  function observeRoots() {
    ["CartDrawer", "main-cart-items"].forEach(function (id) {
      var el = document.getElementById(id) || document.querySelector("#" + id);
      if (el && window.MutationObserver) {
        new MutationObserver(boot).observe(el, { subtree: true, childList: true });
      }
    });
    document.addEventListener("shopify:section:load", boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); observeRoots(); });
  } else {
    boot();
    observeRoots();
  }
})();

/* 24 Jul, third pass: banner image readiness with a grace window.
   Rule learnt the hard way: never animate what is instant. The
   previous pass tagged any not-yet-complete image on the spot, which
   on warm navigations hid cached images the browser could paint
   immediately and then faded them in: a manufactured 700ms delay on
   every internal page. Now every image gets a 180ms grace window (the
   spinner-delay pattern): images that complete inside it are never
   touched and paint natively; only genuinely slow loads get the
   blur-up preview and fade. The hero settle plays once per session
   (sessionStorage flag) on natively-painted banners, never on cold
   blur-up loads and never on repeat navigations. Without JS, no
   classes exist and everything is stock. */
(function () {
  var GRACE = 180;
  var settleAllowed = false;
  try {
    settleAllowed = !sessionStorage.getItem("tarayaHeroSettled");
  } catch (e) {}
  var settleUsed = false;
  function markSettle(img) {
    if (!settleAllowed) return;
    img.classList.add("taraya-settle");
    settleUsed = true;
  }
  function previewUrl(src) {
    try {
      var u = new URL(src, window.location.href);
      if (!/\.(png|jpe?g|webp)(\?|$)/i.test(u.pathname)) return null;
      u.searchParams.set("width", "48");
      return u.href;
    } catch (e) {
      return null;
    }
  }
  var imgs = document.querySelectorAll(
    ".banner__media img, .collection-hero__image-container img"
  );
  imgs.forEach(function (img) {
    if (img.complete && img.naturalWidth) {
      markSettle(img);
      return;
    }
    var treated = false;
    var timer = setTimeout(function () {
      treated = true;
      img.classList.add("taraya-img-wait");
      var holder = img.closest(
        ".banner__media, .collection-hero__image-container"
      );
      var tiny = previewUrl(img.currentSrc || img.src);
      if (holder && tiny) {
        holder.classList.add("taraya-lqip");
        holder.style.backgroundImage = "url('" + tiny + "')";
      }
    }, GRACE);
    var ready = function () {
      clearTimeout(timer);
      if (treated) {
        img.classList.add("taraya-img-ready");
      } else {
        markSettle(img);
      }
    };
    if (img.decode) {
      img.decode().then(ready, ready);
    } else {
      img.addEventListener("load", ready);
    }
    img.addEventListener("error", ready);
  });
  if (settleUsed) {
    try {
      sessionStorage.setItem("tarayaHeroSettled", "1");
    } catch (e) {}
  }
})();


/* 24 Jul: search closes on scroll. The page stays scrollable behind
   the open search (lock neutralised in brand-taraya.css at Aman's
   direction); the on-scroll-up sticky header would carry the open
   panel away mid-scroll, so the first scroll past a small threshold
   closes the search instead: scrolling means done searching. */
(function () {
  var armedAt = null;
  /* Intent gate (Aug 26): only a wheel or touchmove within the last
     250ms counts as the user scrolling. Programmatic scrolls, above
     all iOS scrolling the focused input into view when the keyboard
     opens, fire scroll events without either, and were closing the
     search the moment it was tapped on mobile. */
  var intentAt = 0;
  function markIntent() { intentAt = Date.now(); }
  window.addEventListener("wheel", markIntent, { passive: true });
  window.addEventListener("touchmove", markIntent, { passive: true });

  document.addEventListener(
    "scroll",
    function () {
      var modal = document.querySelector(".header__search details[open]");
      if (!modal) {
        armedAt = null;
        return;
      }
      if (Date.now() - intentAt > 250) return;
      if (armedAt === null) {
        armedAt = window.scrollY;
        return;
      }
      /* 12px: above trackpad drift, below deliberate scrolling, and
         early enough that the exit animation plays before the page
         has visibly travelled under the panel. */
      if (Math.abs(window.scrollY - armedAt) > 12) {
        armedAt = null;
        var dm = modal.closest("details-modal");
        if (dm && typeof dm.close === "function") {
          dm.close(false);
        } else {
          modal.removeAttribute("open");
        }
      }
    },
    { passive: true }
  );
})();


/* 24 Jul: deterministic search exit. details-modal.close() removes
   [open] immediately, which in some engines skips the content before
   any exit transition can play. For the header search only, close is
   wrapped: a closing class triggers the CSS exit, 130ms later the
   original close runs against an already-invisible panel. All close
   paths (Escape, outside click, close button, scroll-close) funnel
   through the same method, so all inherit the choreography. */
(function () {
  /* 25 Jul: installation via whenDefined. The original code grabbed
     the element class at script run time; when details-modal.js
     loads after this file, the lookup returned undefined and the
     wrapper silently never installed, so exits snapped in every
     browser while every CSS exit tune landed behind an unreachable
     code path. whenDefined installs whenever the definition arrives,
     in any load order; prototype patching covers instances that
     already exist. */
  function install(DM) {
    if (!DM || DM.prototype.tarayaWrapped) return;
    DM.prototype.tarayaWrapped = true;
    var orig = DM.prototype.close;
  DM.prototype.close = function (focusToggle) {
    var details = this.querySelector("details");
    var isSearch = this.closest(".header__search");
    if (
      !isSearch ||
      !details ||
      !details.hasAttribute("open") ||
      details.classList.contains("taraya-search-closing")
    ) {
      return orig.call(this, focusToggle);
    }
    var self = this;
    details.classList.add("taraya-search-closing");
    /* Aug 2: the CSS display-hold that keeps the results panel rendered
       through the exit fade is now gated on this attribute, set only
       when the panel was actually open at close time. Without the gate
       the hold force-displayed a stale or empty results container for
       the length of every close, a flash where no panel had been. */
    var ps = details.querySelector("predictive-search");
    var held = ps && ps.hasAttribute("open");
    if (held) ps.setAttribute("data-taraya-hold", "");
    /* 175ms: the exit transition runs 160ms; the old 130ms hold was a
       leftover from a 120ms exit and truncated the last 30ms of every
       close. Hold must always cover the CSS exit duration plus a
       frame. */
    setTimeout(function () {
      details.classList.remove("taraya-search-closing");
      if (held) ps.removeAttribute("data-taraya-hold");
      orig.call(self, focusToggle);
    }, 175);
  };
  }
  var now = customElements.get("details-modal");
  if (now) {
    install(now);
  } else if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("details-modal").then(function () {
      install(customElements.get("details-modal"));
    });
  }
})();
